import { scrollTo } from "@/components/Nav";
import RiverLogo from "@/components/RiverLogo";
import WhaleShark from "@/components/WhaleShark";

export default function Footer() {
    return (
        <footer className="relative overflow-hidden border-t border-[#12283C] bg-[#020D18]" data-testid="footer">
            <WhaleShark
                className="right-[-30px] -top-8 w-[340px]"
                opacity={0.12}
                testid="footer-whale"
            />
            <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-14">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                    <div>
                        <div className="flex items-center gap-2.5">
                            <RiverLogo />
                            <span className="font-display font-semibold tracking-tight text-xl">
                                River<span className="text-sky-200">Guardian</span>
                            </span>
                        </div>
                        <p className="mt-4 text-base text-slate-400 leading-relaxed max-w-sm">
                            A self-funding river restoration service for the Parramatta River, powered by the
                            Guardian fleet and annual council contracts.
                        </p>
                        <p className="mt-5 text-sm text-slate-500 leading-relaxed" data-testid="footer-founders">
                            Founders, Aidan Fahy · Adriano Scenna · Jack Quinn · Max Anderson · Bartholomew Barca
                        </p>
                    </div>
                    <div>
                        <p className="text-sm font-semibold tracking-[0.25em] uppercase text-slate-500">Explore</p>
                        <div className="mt-4 flex flex-col gap-2.5">
                            {[
                                ["crisis", "The Issue"],
                                ["product", "The Guardian"],
                                ["culture", "Culture & Country"],
                                ["financials", "Financials"],
                                ["roadmap", "Expansion"],
                                ["contact", "Partner With Us"],
                            ].map(([id, label]) => (
                                <button
                                    key={id}
                                    data-testid={`footer-link-${id}`}
                                    onClick={() => scrollTo(id)}
                                    className="text-left text-base text-slate-400 hover:text-sky-200 transition-colors w-fit"
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div>
                        <p className="text-sm font-semibold tracking-[0.25em] uppercase text-slate-500">Acknowledgement</p>
                        <p className="mt-4 text-base text-slate-400 leading-relaxed">
                            RiverGuardian acknowledges the Wallumedegal, Burramattagal, Wangal and Gadigal
                            peoples, the Traditional Custodians of the lands and waters of the Parramatta River
                            catchment and Sydney Harbour, and the Dharug and Eora language groups. We pay our
                            respects to Elders past and present, and commit to caring for Country in everything
                            we build.
                        </p>
                    </div>
                </div>
                <div className="mt-12 pt-6 border-t border-[#12283C] flex flex-wrap items-center justify-between gap-3 text-sm text-slate-500">
                    <p data-testid="footer-copy">© 2026 RiverGuardian. All figures are modelled projections unless otherwise cited.</p>
                    <p>Data: NSW EPA, Sydney Water, NSW Health</p>
                </div>
            </div>
        </footer>
    );
}
